export const SmarticoEvents = {
  init: "init",
  identity: "identity",
  identify: "identify",
  props_change: "props_change",
  login: "login",
  logout: "logout",
  gf_starting: "gf_starting",
  gf_closing: "gf_closing",
} as const;
